module.exports = __webpack_public_path__ + "img/payment-method-ip8.a703a572.png";